import { makePostApiCall } from "./makeApiCall";
import type { UserDepartmentCode, UserTypeCode } from "./userReferenceCodes";

type OneOrMany<T extends string> = T | readonly T[];

function normalizeCodes<T extends string>(codes: OneOrMany<T>): T[] {
  return typeof codes === "string" ? [codes] : [...codes];
}

export async function fetchUsersForDropdown(
  typeCodes: OneOrMany<UserTypeCode>,
  departmentCodes: OneOrMany<UserDepartmentCode>,
) {
  return makePostApiCall("usersForDropdown", {
    type_codes: normalizeCodes(typeCodes),
    department_codes: normalizeCodes(departmentCodes),
  });
}
